<template>
  <b-card
  class="video-item"
    overlay
    :img-src="`${baseurl}${item.videocover}`"
    text-variant="white"
    @mouseover="show = true"
    @mouseleave="show = false"
  >
    <b-card-title
      ><span>{{ item.name }}</span></b-card-title
    >
    <b-card-body>
      <div class="videofooter">
        <div class="row">
          <div class="col-10">
            <div class="videofooter">
              <div class="mb-2">
                <div class="label label-inline label-info">
                  {{ item.category.label }}
                </div>
              </div>
              <div class="mb-2">
                <div class="label label-inline label-dark">
                  {{ item.duration }}
                </div>
              </div>
              <div class="label label-inline">{{ item.date[0] }}</div>
            </div>
          </div>
          <transition name="slide">
            <div class="tools col-2" v-if="show">
              <router-link
                :to="`/video/edit/${item.id}`"
                class="btn btn-sm btn-warning btn-icon mb-1"
                v-tooltip="{ content: 'ویرایش' }"
                ><i class="la la-edit"></i
              ></router-link>
              <button
                class="btn btn-sm btn-info btn-icon  mb-1"
                @click="showDialog = true"
                v-tooltip="{ content: 'نمایش' }"
              >
                <i class="la la-eye"></i>
              </button>
              <button
                class="btn btn-sm btn-danger btn-icon  mb-1"
                v-tooltip="{ content: 'حذف' }"
                @click="remove(item.id)"
              >
                <i class="la la-trash"></i>
              </button>
            </div>
          </transition>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import ApiService from "@/core/services/api.service";
export default {
  name: "video-item",
  props: {
    item: {
      require: true
    }
  },
  data() {
    return {
      show: false,
      showDialog: false,
      page: 0
    };
  },
  computed: {
    baseurl() {
      return ApiService.baseurl;
    }
  },
  methods: {
    remove: function(id) {
      let thisv = this;
      ApiService.delete("admin/video/" + id)
        .then(({ data }) => {
          this.changepage(this.page);

          this.$vs.notification({
            progress: "auto",
            color: "danger",
            position: "bottom-left",
            text: "ویدئو با موفقیت حذف شد"
          });
        })
        .catch(({ response }) => {});
    }
  }
};
</script>

<style lang="scss">
.video-item {
  width: 100%;
  margin: 10px 0;
  transition: 400ms;
  .position-relative{
   height: 234px;
 
  }
  .card-img {
       height: 234px;
    object-fit: cover;
  }
  .card-body{
    height: 234px;
   }
  .card-title {
    span {
      background: #919191b3;
      line-height: normal;
      padding: 0 7px;
      font-size: 15px;
      border-radius: 5px;
      box-shadow: 0 2px 1px #ff000054;
    }
  }

  .card-img-overlay {
    &:before {
      transition: 400ms;
      content: " ";
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(81, 90, 103, 0.6643032212885154) 100%
      );
    }
  }

  &:hover {
    .card-img-overlay {
      &:before {
        opacity: 0.4;
      }
    }
  }
}

.videofooter {
  width: 100%;
  position: absolute;
  bottom: 0px;
  right: 0px;
  padding: 10px;
}

.slide-leave-active,
.slide-enter-active {
  transition: 400ms;
  opacity: 1;
}
.slide-enter {
  transform: translate(100%, 0);
  opacity: 0;
}
.slide-leave-to {
  transform: translate(0, 0);
  opacity: 0;
}

.md-dialog .md-dialog-container {
  max-width: 768px;
}
</style>
